import { Images } from 'assets/images';

export const QuestionsHeader = [
  'id',
  'title',
  'position',
  'answer_type',
  'visibility',
];

export const UsersHeader = ['id', 'name', 'email', 'birthdate', 'blocked', 'role'];
export const CustomersHeader = [
  'id',
  'name',
  'email',
  'birthdate',
  'blocked',
  'role',
  'request_limit',
];

export const RequestsHeader = [
  'id',
  'Name',
  'Status',
  'Operator',
  'Received',
  'sent',
];

export const PACKAGES_HEADER = [
  'title',
  'description',
  'country',
  'city',
  'frequency',
];

export const PACKAGE_DATA = [
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 12,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 11,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 10,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 9,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 8,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 7,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 6,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 5,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 4,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 3,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 2,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
  {
    title: 'Gago',
    description: 'lorem lorem lorem',
    country: 'Yerevan, Armenia',
    city: 'Yerevan',
    frequency: '123',
    id: 1,
    stay_days: 12,
    stay_nights: 11,
    price: '750 $',
    language: 'english',
    population: '30000000',
    ticket_url: 'https://github.com/Baghdasarov/itah-fe/actions',
    booking_url: 'https://www.youtube.com/watch?v=bSfpSOBD30U',
  },
];

export const UserData = [
  {
    id: '12',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '0',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '1',
    name: 'Suren',
    email: 'sdsd@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '15',
    name: 'Tiko',
    email: 'Jsds@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '1654',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '324',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '23413',
    name: 'Suren',
    email: 'sdsd@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '10',
    name: 'Tiko',
    email: 'Jsds@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '124',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '40',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '210',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '211',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '212',
    name: 'Suren',
    email: 'sdsd@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '213',
    name: 'Tiko',
    email: 'Jsds@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '214',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '215',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '216',
    name: 'Suren',
    email: 'sdsd@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '220',
    name: 'Tiko',
    email: 'Jsds@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '221',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '222',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '223',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '32',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '44',
    name: 'Suren',
    email: 'sdsd@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '5',
    name: 'Tiko',
    email: 'Jsds@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '55',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
  {
    id: '62',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '63',
    name: 'Suren',
    email: 'sdsd@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'Admin',
  },
  {
    id: '28',
    name: 'Tiko',
    email: 'Jsds@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'Admin',
  },
];

export const CustomerData = [
  {
    id: '12',
    name: 'Hayko',
    email: 'vsdw@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'User',
    request_limit: '3',
    action: [Images.editButton],
  },
  {
    id: '0',
    name: 'Davit',
    email: 'aqed@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'User',
    request_limit: '2',
    action: [Images.editButton],
  },
  {
    id: '1',
    name: 'Suren',
    email: 'sdsd@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'No',
    role: 'User',
    request_limit: '1',
    action: [Images.editButton],
  },
  {
    id: '15',
    name: 'Tiko',
    email: 'Jsds@gmail.com',
    birthdate: '2023/12/12',
    blocked: 'Yes',
    role: 'User',
    request_limit: '4',
    action: [Images.editButton],
  },
];

export const QuestionData = [
  {
    id: '9',
    title: 'Raice',
    position: '2',
    answer_type: 'Checkbox',
    visibility: 'On',
  },
  {
    id: '93',
    title: 'Raice',
    position: '1',
    answer_type: 'Text',
    visibility: 'Off',
  },
  {
    id: '12',
    title: 'Raice',
    position: '9',
    answer_type: 'Checkbox',
    visibility: 'On',
  },
  {
    id: '59',
    title: 'Raice',
    position: '12',
    answer_type: 'Other',
    visibility: 'Off',
  },
];

export const RequestsData = [
  {
    id: '1',
    Name: 'Raice',
    Status: 'In Progress',
    Operator: 'Ruben Petrosyan',
    Received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
  {
    id: '9',
    Name: 'Raice',
    Status: 'In Progress',
    Operator: 'Ruben Petrosyan',
    Received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
  {
    id: '19',
    Name: 'Raice',
    Status: 'In Progress',
    Operator: 'Ruben Petrosyan',
    Received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
  {
    id: '69',
    Name: 'Raice',
    Status: 'In Progress',
    Operator: 'Ruben Petrosyan',
    Received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
];

export const MyRequestsData = [
  {
    id: '4',
    Name: 'sadasd',
    Status: 'In asd',
    Operator: 'sad asdasd',
    Received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
  {
    id: '19',
    Name: 'asdas',
    Status: 'In asdasf',
    Operator: 'Ruben Petrosyan',
    Received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
  {
    id: '9',
    Name: 'dfdf',
    Status: 'In gfd',
    Operator: 'Ruben Petrosyan',
    Received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
  {
    id: '9',
    Name: 'Raice',
    Status: 'In Progress',
    Operator: 'Ruben Petrosyan',
    Received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
];
